import { __assign, __rest } from "tslib";
import React from 'react';
import { FormControl, FormLabel, HStack } from '@chakra-ui/react';
import TextComponent from '../_components/TextComponent';
var FormItemWrapper = function (_a) {
    var error = _a.error, noTopSpace = _a.noTopSpace, isRequired = _a.isRequired, name = _a.name, label = _a.label, helperText = _a.helperText, children = _a.children, props = __rest(_a, ["error", "noTopSpace", "isRequired", "name", "label", "helperText", "children"]);
    return (React.createElement(FormControl, __assign({ isInvalid: !!error }, props),
        React.createElement(HStack, { h: noTopSpace ? 0 : 10, w: 'full' },
            label && (React.createElement(FormLabel, { m: 0, htmlFor: name },
                label,
                isRequired ? ' * ' : '')),
            React.createElement(TextComponent, { tooltip: error, flex: 1, color: 'red.400', w: 'full', justifyContent: 'flex-end', fontSize: 'xs' }, error)),
        helperText && (React.createElement(TextComponent, { color: 'gray.500', pb: 0.5, tooltip: helperText, w: 'full', fontSize: 'sm' }, helperText)),
        children));
};
export default FormItemWrapper;
//# sourceMappingURL=FormItemWrapper.js.map